// @ts-nocheck
/// <reference path="../types.d.ts"/>
/** @module action/ProductList */
// Auto-generated, edits will be overwritten
import * as ProductList from '../ProductList';

export const MY_LISTS_START = 's/ProductList/MY_LISTS_START';
export const MY_LISTS = 's/ProductList/MY_LISTS';
export type MY_LISTS = api.ProductListWithProducts[];

export function myLists(options?: ProductList.MyListsOptions, info?: any): api.AsyncAction {
  return dispatch => {
    dispatch({ type: MY_LISTS_START, meta: { info, params: { options } } });
    return ProductList.myLists(options)
      .then(response => dispatch({
        type: MY_LISTS,
        payload: response.data,
        error: response.error,
        meta: {
          res: response.raw,
          info
        }
      }));
  };
}

export const CREATE_START = 's/ProductList/CREATE_START';
export const CREATE = 's/ProductList/CREATE';
export type CREATE = api.ProductListWithProducts;

export function create(options?: ProductList.CreateOptions, info?: any): api.AsyncAction {
  return dispatch => {
    dispatch({ type: CREATE_START, meta: { info, params: { options } } });
    return ProductList.create(options)
      .then(response => dispatch({
        type: CREATE,
        payload: response.data,
        error: response.error,
        meta: {
          res: response.raw,
          info
        }
      }));
  };
}

export const UPDATE_START = 's/ProductList/UPDATE_START';
export const UPDATE = 's/ProductList/UPDATE';
export type UPDATE = api.ProductListWithProducts;

export function update(id: number, options?: ProductList.UpdateOptions, info?: any): api.AsyncAction {
  return dispatch => {
    dispatch({ type: UPDATE_START, meta: { info, params: { id, options } } });
    return ProductList.update(id, options)
      .then(response => dispatch({
        type: UPDATE,
        payload: response.data,
        error: response.error,
        meta: {
          res: response.raw,
          info
        }
      }));
  };
}

export const DESTROY_START = 's/ProductList/DESTROY_START';
export const DESTROY = 's/ProductList/DESTROY';
export type DESTROY = api.ProductList;

export function destroy(id: number, options?: ProductList.DestroyOptions, info?: any): api.AsyncAction {
  return dispatch => {
    dispatch({ type: DESTROY_START, meta: { info, params: { id, options } } });
    return ProductList.destroy(id, options)
      .then(response => dispatch({
        type: DESTROY,
        payload: response.data,
        error: response.error,
        meta: {
          res: response.raw,
          info
        }
      }));
  };
}

export const GET_PRODUCT_LISTS_START = 's/ProductList/GET_PRODUCT_LISTS_START';
export const GET_PRODUCT_LISTS = 's/ProductList/GET_PRODUCT_LISTS';
export type GET_PRODUCT_LISTS = api.ProductListWithProductsDto[];

export function getProductLists(options?: ProductList.GetProductListsOptions, info?: any): api.AsyncAction {
  return dispatch => {
    dispatch({ type: GET_PRODUCT_LISTS_START, meta: { info, params: { options } } });
    return ProductList.getProductLists(options)
      .then(response => dispatch({
        type: GET_PRODUCT_LISTS,
        payload: response.data,
        error: response.error,
        meta: {
          res: response.raw,
          info
        }
      }));
  };
}

export const CREATE_PRODUCT_LIST_START = 's/ProductList/CREATE_PRODUCT_LIST_START';
export const CREATE_PRODUCT_LIST = 's/ProductList/CREATE_PRODUCT_LIST';
export type CREATE_PRODUCT_LIST = api.ProductListWithProductsDto;

export function createProductList(productList: api.ProductListDto, options?: ProductList.CreateProductListOptions, info?: any): api.AsyncAction {
  return dispatch => {
    dispatch({ type: CREATE_PRODUCT_LIST_START, meta: { info, params: { productList, options } } });
    return ProductList.createProductList(productList, options)
      .then(response => dispatch({
        type: CREATE_PRODUCT_LIST,
        payload: response.data,
        error: response.error,
        meta: {
          res: response.raw,
          info
        }
      }));
  };
}

export const UPDATE_PRODUCT_LIST_START = 's/ProductList/UPDATE_PRODUCT_LIST_START';
export const UPDATE_PRODUCT_LIST = 's/ProductList/UPDATE_PRODUCT_LIST';
export type UPDATE_PRODUCT_LIST = api.ProductListWithProductsDto;

export function updateProductList(id: number, productList: api.ProductListDto, options?: ProductList.UpdateProductListOptions, info?: any): api.AsyncAction {
  return dispatch => {
    dispatch({ type: UPDATE_PRODUCT_LIST_START, meta: { info, params: { id, productList, options } } });
    return ProductList.updateProductList(id, productList, options)
      .then(response => dispatch({
        type: UPDATE_PRODUCT_LIST,
        payload: response.data,
        error: response.error,
        meta: {
          res: response.raw,
          info
        }
      }));
  };
}

export const DELETE_PRODUCT_LIST_START = 's/ProductList/DELETE_PRODUCT_LIST_START';
export const DELETE_PRODUCT_LIST = 's/ProductList/DELETE_PRODUCT_LIST';
export type DELETE_PRODUCT_LIST = undefined;

export function deleteProductList(id: number, options?: ProductList.DeleteProductListOptions, info?: any): api.AsyncAction {
  return dispatch => {
    dispatch({ type: DELETE_PRODUCT_LIST_START, meta: { info, params: { id, options } } });
    return ProductList.deleteProductList(id, options)
      .then(response => dispatch({
        type: DELETE_PRODUCT_LIST,
        payload: response.data,
        error: response.error,
        meta: {
          res: response.raw,
          info
        }
      }));
  };
}

export const ADD_PRODUCT_LIST_ITEM_START = 's/ProductList/ADD_PRODUCT_LIST_ITEM_START';
export const ADD_PRODUCT_LIST_ITEM = 's/ProductList/ADD_PRODUCT_LIST_ITEM';
export type ADD_PRODUCT_LIST_ITEM = api.ProductListWithProductsDto;

export function addProductListItem(id: number, cartItem: api.CartItemDto, options?: ProductList.AddProductListItemOptions, info?: any): api.AsyncAction {
  return dispatch => {
    dispatch({ type: ADD_PRODUCT_LIST_ITEM_START, meta: { info, params: { id, cartItem, options } } });
    return ProductList.addProductListItem(id, cartItem, options)
      .then(response => dispatch({
        type: ADD_PRODUCT_LIST_ITEM,
        payload: response.data,
        error: response.error,
        meta: {
          res: response.raw,
          info
        }
      }));
  };
}

export const REMOVE_PRODUCT_LIST_ITEM_START = 's/ProductList/REMOVE_PRODUCT_LIST_ITEM_START';
export const REMOVE_PRODUCT_LIST_ITEM = 's/ProductList/REMOVE_PRODUCT_LIST_ITEM';
export type REMOVE_PRODUCT_LIST_ITEM = api.ProductListWithProductsDto;

export function removeProductListItem(id: number, itemId: string, options?: ProductList.RemoveProductListItemOptions, info?: any): api.AsyncAction {
  return dispatch => {
    dispatch({ type: REMOVE_PRODUCT_LIST_ITEM_START, meta: { info, params: { id, itemId, options } } });
    return ProductList.removeProductListItem(id, itemId, options)
      .then(response => dispatch({
        type: REMOVE_PRODUCT_LIST_ITEM,
        payload: response.data,
        error: response.error,
        meta: {
          res: response.raw,
          info
        }
      }));
  };
}

export const UPDATE_PRODUCT_LIST_ITEM_START = 's/ProductList/UPDATE_PRODUCT_LIST_ITEM_START';
export const UPDATE_PRODUCT_LIST_ITEM = 's/ProductList/UPDATE_PRODUCT_LIST_ITEM';
export type UPDATE_PRODUCT_LIST_ITEM = api.ProductListWithProductsDto;

export function updateProductListItem(id: number, itemId: string, cartItem: api.CartItemDto, options?: ProductList.UpdateProductListItemOptions, info?: any): api.AsyncAction {
  return dispatch => {
    dispatch({ type: UPDATE_PRODUCT_LIST_ITEM_START, meta: { info, params: { id, itemId, cartItem, options } } });
    return ProductList.updateProductListItem(id, itemId, cartItem, options)
      .then(response => dispatch({
        type: UPDATE_PRODUCT_LIST_ITEM,
        payload: response.data,
        error: response.error,
        meta: {
          res: response.raw,
          info
        }
      }));
  };
}

export const MOVE_PRODUCT_LIST_ITEMS_START = 's/ProductList/MOVE_PRODUCT_LIST_ITEMS_START';
export const MOVE_PRODUCT_LIST_ITEMS = 's/ProductList/MOVE_PRODUCT_LIST_ITEMS';
export type MOVE_PRODUCT_LIST_ITEMS = api.ProductListWithProductsDto[];

export function moveProductListItems(targetListId: number, sourceListId: number, productListMoveItems: api.ProductListMoveItemsDto, options?: ProductList.MoveProductListItemsOptions, info?: any): api.AsyncAction {
  return dispatch => {
    dispatch({ type: MOVE_PRODUCT_LIST_ITEMS_START, meta: { info, params: { targetListId, sourceListId, productListMoveItems, options } } });
    return ProductList.moveProductListItems(targetListId, sourceListId, productListMoveItems, options)
      .then(response => dispatch({
        type: MOVE_PRODUCT_LIST_ITEMS,
        payload: response.data,
        error: response.error,
        meta: {
          res: response.raw,
          info
        }
      }));
  };
}
